import type { ReactNode } from 'react';
import { TableEmptyState } from './TableEmptyState';

type TableResultsProps = {
  readonly isEmpty: boolean;
  readonly loading?: boolean;
  readonly children: ReactNode;
  readonly emptyState?: ReactNode;
};

export const TableResults = ({
  isEmpty,
  loading = false,
  children,
  emptyState = <TableEmptyState />,
}: TableResultsProps) => <>{isEmpty && !loading ? emptyState : children}</>;
